import { axiosInstanceFast } from "./axiosInstance";

export const getDdrAllUsersList = async (
  data: {
    page: number;
    page_size: number;
    source?: string;
    search_text?: string;
    sort_key?: string;
    sort_order?: string;
    search_columns?: string[];
    data_source?: string; // plugin id
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/get-list",
    data,
    { signal },
  );
  return response.data;
};

export const getMostAccessUsers = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/get-most-access-list",
    {},
    { signal },
  );
  return response.data.data;
};

export const getAnomalousUsersList = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/anomalous-users",
    {},
    { signal },
  );
  return response.data.data;
};

export const getUserDeails = async (
  data: {
    username: string; // either name or email
    user_id?: number; // id of the user
    is_external?: number;
    plugin_id?: string;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/get-details",
    data,
    { signal },
  );
  return response.data.data;
};

export const getWatchedUsersList = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get(
    "/rdd/api/v1/user/get-watchlist",
    { signal },
  );
  return response.data.data;
};

export const updateUserWatchlist = async (user_id: number) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/update-watchlist",
    {
      user_id,
    },
  );
  return response.data.data;
};

export const getUserFileSize = async (
  user_id: number,
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post(
    "/rdd/api/v1/user/get-file-size-category",
    {
      user_id,
    },
    { signal },
  );
  return response.data.data;
};

export const getUserListSummary = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get(
    "/rdd/api/v1/user/source-summary",
    { signal },
  );
  return response.data.data;
};

export const getAllUnmanagedUsers = async (signal?: AbortSignal) => {
  const response = await axiosInstanceFast.get(
    "/rdd/api/v1/user/network-users",
    { signal },
  );
  return response.data.data;
};

export const getSuperUsers = async (
  data: {
    sub_source?: string[];
    filter_user?: Record<string, string>;
  },
  signal?: AbortSignal,
) => {
  const response = await axiosInstanceFast.post("/user/admin-users", data, {
    signal,
  });
  return response.data;
};

// export const updateAttributes = async (
//   data: {
//     username: string;
//     attributes: {
//       name: string;
//       isCustom: boolean;
//       value: any;
//     }[];
//   },
//   signal?: AbortSignal,
// ) => {
//   const response = await axiosInstanceFast.put(
//     "/user/update-attributes",
//     data,
//     { signal },
//   );
//   return response.data;
// };
